import { useEffect, useState } from "react";
import { URL_API } from "../../utils/helper/helpers";
import axios from "axios";
import { toast } from "react-toastify";

interface UserInterface {
    [key: string]: any;
}

const useUsersListe = (refresh: boolean): UserInterface[] => {
    const [users, setUsers] = useState<UserInterface[]>([]);
    const Token = JSON.parse(localStorage.getItem("login")!);

    useEffect(() => {
        const fetchUsers = async () => {
            axios.get(`${URL_API}/user/all`, {
                headers: {
                    Authorization: `Bearer ${Token}`
                }
            }).then(response => {

                if (response.status == 200) {
                    setUsers(response.data.users);
                }

            }).catch(error => {
                if (error.status === 400) {
                    toast.info(error.response.data.message);
                }

                if (error.status === 500) {
                    toast.warning(error.response.data.message);
                }
            })
        };

        fetchUsers();
    }, [refresh]);
    return users;
};

export default useUsersListe;

export const deleteUsers = async ({ id }: { id: number }, onSuccess: () => void) => {
    const Token = JSON.parse(localStorage.getItem("login")!);

    axios.post(`${URL_API}/user/delete`, { id }, {
        headers: {
            Authorization: `Bearer ${Token}`
        }
    }).then(response => {

        if (response.data.success) {
            toast.warning("Rôle Supprimer avec succès")
            onSuccess();
        }

    }).catch(error => {
        if (error.status === 405) {
            toast.info(error.response.data.message)
        }
        toast.info('Server Error')
    })

}

export const changeStatus = ({ id }: { id: number }, onSuccess: () => void) => {
    const Token = JSON.parse(localStorage.getItem("login")!);
    axios.post(`${URL_API}/user/block`, { id }, {
        headers: {
            Authorization: `Bearer ${Token}`
        }
    }).then(response => {

        if (response.data.success) {
            toast.success("Status Changé avec success")
            onSuccess();
        }

    }).catch(error => {
        if (error.status === 405) {
            toast.info(error.response.data.message)
        }
    })

}